import Fetch from "utils/fetch";

export const aceitarRenegociacaoPedidoAtenderDemanda = (pedido) => {
  return Fetch.post(`/negotiations/${pedido.idNegotiation}:accept-renegotiation`, pedido).then(({ data }) => data) 
  
}

export const recusarRenegociacaoPedidoAtenderDemanda = (pedido) => {
    return Fetch.post(`/pedido/recusarRenegociacaoPedidoAtenderDemanda`, pedido).then(({ data }) => data)
}